module.exports = __webpack_public_path__ + "img/domain-01-mobile.3fb102c6.png";